<template>
  <nuxt-link
    class="card"
    :class="cardAnimated"
    :to="`/events/${event.slug}`"
    @click="trackEvent"
  >
    <div class="card-image-column">
      <span
        class="card-balloon"
        :class="showBalloon"
      >
        EXCLUSIVE WORKSHOP
      </span>
      <div class="card-image-wrapper">
        <img
          v-if="eventImage"
          class="card-image"
          :src="eventImage"
          alt="best-practice"
          loading="lazy"
        />
        <NuxtPicture
          v-else
          class="card-image"
          src="/images/events-page/placeholder.png"
          alt="placeholder"
          lazy
        />
      </div>
      <div class="card-tags">
        <span
          v-if="eventTag"
          class="card-white-tag"
        >
          {{ eventTag }}
        </span>
        <span
          v-if="event.private"
          class="card-purple-tag"
        >
          <NuxtImg
            class="logo-symbol"
            src="/images/events-page/hero/logo-symbol.svg"
            alt="logo-symbol"
            lazy
          />
          Members only
        </span>
      </div>
    </div>
    <div class="card-content">
      <div>
        <div class="date">
          <NuxtImg
            class="date-icon"
            src="/images/events-page/hero/date-icon.svg"
            alt="date-icon"
            lazy
          />
          <span class="day">{{ event.event_date }}</span>
          <span class="hour">· {{ event.event_hour }} CET</span>
        </div>
        <h1 class="card-content-title">
          {{ event.title }}
        </h1>
        <div
          v-if="event.speaker !== null"
          class="author"
        >
          <img
            v-if="speakerImage"
            class="author-image"
            :src="speakerImage"
            alt="author"
          />
          <div class="author-info">
            <span class="author-name">{{ event.speaker?.name }}</span>
            <span class="author-role">{{ event.speaker?.title }}</span>
          </div>
        </div>
      </div>
      <button class="btn btn-desktop">LEARN MORE</button>
      <button class="btn-mobile">
        <ReadMore
          text="Learn More"
          show
        />
      </button>
    </div>
  </nuxt-link>
</template>

<script>
import ReadMore from '~/components/Common/ReadMore/ReadMore.vue';
import cloudinaryImage from '~/utils/helpers/cloudinaryImage';
import { useEventsStore } from '~/stores/events';

export default {
  components: { ReadMore },
  data() {
    return {
      showBalloon: '',
      cardAnimated: '',
      eventsStore: useEventsStore(),
    };
  },
  computed: {
    event() {
      return this.eventsStore.mainEvent;
    },
    eventTag() {
      return this.event.tags?.length ? this.event.tags[0].title : false;
    },
    eventImage() {
      return this.event.header_image
        ? cloudinaryImage({ imagePath: this.event.header_image, width: 700 })
        : null;
    },
    speakerImage() {
      return this.event.speaker?.image
        ? cloudinaryImage({ imagePath: this.event.speaker.image, width: 100 })
        : null;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.cardAnimated = 'card-animated';
      this.balloonTimeout = setTimeout(() => {
        this.showBalloon = 'card-balloon-show';
      }, 500);
    });
  },
  beforeUnmount() {
    clearTimeout(this.balloonTimeout);
  },
  methods: {
    trackEvent() {
      this.$analytics.track('CTA Clicked', {
        cta_name: 'Learn more',
        page_name: 'Homepage_Events',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './HeroCard.scss';
</style>
